import { connect } from 'react-redux'
import HomeUI from './HomeUI'
import { Dispatch } from 'redux';
import ApplicationState from '../../../../ApplicationState';
import IDispatcher from '../../../Util/IDispatcher';
import IState from '../../../Util/IState';
import HomeState from '../../State/HomeState';
import { actionFetchUser } from '../../Actions/ActionCreator';
import HomeDispatch from './model';



const mapStateToProps = (state: ApplicationState): IState<HomeState> => {
    return {
        state: state.home
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<HomeDispatch> => ({
    dispatcher: {
        fetch: () => { dispatch(actionFetchUser() as any) }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(HomeUI)